<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login login-1 d-flex flex-column flex-lg-row flex-column-fluid bg-white"
      :class="{
        'login-signin-on': this.state === 'signin',
        'login-signup-on': this.state === 'signup'
      }"
      id="kt_login"
    >
      <!--begin::Aside-->
      <div class="login-aside d-flex flex-column flex-row-auto bg-gray-100">
        <div class="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
          <a href="#" class="text-center mb-10">
            <img src="/media/logos/logo.png" class="max-h-70px" alt="mirol" />
          </a>
          <h3
            class="font-weight-bolder text-center font-size-h4 font-size-h1-lg text-primary"
          >
            سرویس پخش زنده همزمان
          </h3>
        </div>
        <div
          class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center bgi-size-contain"
          :style="{ backgroundImage: `url(${backgroundImage})` }"
        ></div>
      </div>
      <!--begin::Aside-->
      <!--begin::Content-->
      <div
        class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto"
      >
        <div class="d-flex flex-column-fluid flex-center">
          <!--begin::Signin-->
          <div class="login-form login-signin">
            <form class="form" novalidate="novalidate" id="signin_form">
              <div class="pb-13 pt-lg-0 pt-5">
                <h3
                  class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                >
                  ورود کاربران
                </h3>
              </div>
              <div class="form-group">
                <label class="font-size-h6 font-weight-bolder text-dark">
                  شماره همراه
                </label>
                <the-mask
                  mask="09## ### ## ##"
                  v-model="form.cellphone"
                  :masked="true"
                  name="cellphone"
                  ref="cellphone"
                  placeholder="09__ ___ __ __"
                  class="form-control form-control-solid form-control-lg mb-2 text-center"
                  dir="ltr"
                  autocomplete="off"
                ></the-mask>
              </div>
              <div class="form-group">
                <div class="d-flex justify-content-between mt-n5">
                  <label class="font-size-h6 font-weight-bolder text-dark pt-5">
                    گذرواژه
                  </label>
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i
                        class="fa"
                        @click="showPassword = !showPassword"
                        :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']"
                      ></i
                    ></span>
                  </div>
                  <input
                    class="form-control"
                    :type="[showPassword ? 'text' : 'password']"
                    name="password"
                    ref="password"
                    dir="ltr"
                    v-model="form.password"
                    autocomplete="off"
                  />
                </div>
              </div>

              <div class="pb-lg-0 pb-5">
                <button
                  ref="signin_submit"
                  class="btn btn-primary font-weight-bolder font-size-h6 px-15 py-4 my-3 mr-3"
                >
                  ورود
                </button>
                <router-link
                  :to="{ name: 'otp' }"
                  class="btn btn-light-primary font-weight-bolder px-8 py-4 my-3 font-size-lg"
                >
                  <span class="svg-icon svg-icon-md">
                    <inline-svg
                      src="/media/svg/icons/Communication/Incoming-call.svg"
                    />
                  </span>
                  ورود با کد یک‌بار مصرف
                </router-link>
              </div>
            </form>
          </div>
          <!--end::Signin-->
          <!--begin::Signup-->
          <div class="login-form login-signup">
            <form class="form" novalidate="novalidate" id="signup_form">
              <div class="pb-13 pt-lg-0 pt-5">
                <h3 class="font-weight-bolder text-dark font-size-h6">
                  نام‌نویسی
                </h3>
                <p class="text-muted font-weight-bold font-size-h4">
                  اطلاعات خود را وارد کنید
                </p>
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="text"
                  placeholder="first_name"
                  name="first_name"
                  ref="first_name"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="email"
                  placeholder="Email"
                  name="email"
                  ref="remail"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="password"
                  placeholder="Password"
                  name="password"
                  ref="rpassword"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="password"
                  placeholder="Confirm password"
                  name="cpassword"
                  ref="cpassword"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <label class="checkbox mb-0">
                  <input type="checkbox" name="agree" />
                  <span class="mr-2"></span>
                  I Agree the
                  <a href="#" class="ml-2">terms and conditions</a>.
                </label>
              </div>
              <div class="form-group d-flex flex-wrap pb-lg-0 pb-3">
                <button
                  ref="kt_login_signup_submit"
                  class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4"
                  style="width: 150px"
                >
                  ارسال
                </button>
                <button
                  type="button"
                  id="kt_login_signup_cancel"
                  class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"
                  @click="showForm('signin')"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
          <!--end::Signup-->
        </div>
        <!--begin::Content footer-->
        <div
          class="d-flex justify-content-lg-start justify-content-center align-items-end py-7 py-lg-0"
        >
          <a
            href="https://mirol.ir/"
            class="text-primary font-weight-bolder font-size-h5"
          >
            خانه
          </a>
          <a
            href="https://mirol.ir/docs"
            class="text-primary ml-10 font-weight-bolder font-size-h5"
          >
            راهنما
          </a>
          <a
            href="https://mirol.ir/terms"
            class="text-primary ml-10 font-weight-bolder font-size-h5"
          >
            شرایط استفاده
          </a>
          <a
            href="https://mirol.ir/privacy"
            class="text-primary ml-10 font-weight-bolder font-size-h5"
          >
            حریم خصوصی
          </a>
        </div>
        <!--end::Content footer-->
      </div>
      <!--end::Content-->
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";
import KTUtil from "@/assets/js/components/util";
import { LOGIN, PURGE_AUTH } from "@/core/services/store/auth.module";
import { TheMask } from "vue-the-mask";
import { INIT_INFO } from "@/core/services/store/profile.module";
import JwtService from "@/core/services/jwt.service";

export default {
  name: "login-1",
  data() {
    return {
      state: "signin",
      form: {
        cellphone: "",
        password: ""
      },
      showPassword: false
    };
  },
  components: {
    TheMask
  },
  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "media/login.png";
    }
  },
  mounted() {
    const signin_form = KTUtil.getById("signin_form");
    const signup_form = KTUtil.getById("signup_form");

    this.fv = formValidation(signin_form, {
      fields: {
        cellphone: {
          validators: {
            notEmpty: {
              message: "شماره همراه اجباری است"
            }
          }
        },
        password: {
          validators: {
            notEmpty: {
              message: "گذرواژه اجباری است"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap()
      }
    });

    this.fv1 = formValidation(signup_form, {
      fields: {
        fullname: {
          validators: {
            notEmpty: {
              message: "Full name is required"
            }
          }
        },
        cellphone: {
          validators: {
            notEmpty: {
              message: "cellphone is required"
            },
            cellphoneAddress: {
              message: "The value is not a valid cellphone address"
            }
          }
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password is required"
            }
          }
        },
        cpassword: {
          validators: {
            notEmpty: {
              message: "Confirm password is required"
            },
            identical: {
              compare: function() {
                return signup_form.querySelector('[name="password"]').value;
              },
              message: "The password and its confirm are not the same"
            }
          }
        },
        agree: {
          validators: {
            notEmpty: {
              message: "You should agree terms and conditions"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap()
      }
    });

    this.fv.on("core.form.valid", () => {
      let cellphone = this.parsePhone(this.form.cellphone);
      let password = this.form.password;

      this.$store.commit(PURGE_AUTH);

      const submitButton = this.$refs["signin_submit"];
      this.disableBtn(submitButton);

      this.$store
        .dispatch(LOGIN, { cellphone, password })
        .then(response => {
          this.$store.dispatch(INIT_INFO, response.user);
          this.enableBtn(submitButton);
          this.redirect();
        })
        .catch(error => {
          this.showError(error.data.message);

          this.enableBtn(submitButton);
        });
    });

    this.fv.on("core.form.invalid", () => {
      this.showError("لطفا اطلاعات را به درستی وارد کنید");
    });

    this.fv1.on("core.form.valid", () => {});

    this.fv1.on("core.form.invalid", () => {
      this.showError("لطفا اطلاعات را به درستی وارد کنید");
    });
  },
  methods: {
    showForm(form) {
      this.state = form;
      let form_name = "kt_login_" + form + "_form";
      KTUtil.animateClass(
        KTUtil.getById(form_name),
        "animate__animated animate__backInUp"
      );
    },
    redirect() {
      if (this.$route.query.refer) {
        window.location.href = `${this.$route.query.refer.toString()}/?token=${JwtService.getToken()}`;
      } else {
        this.$router.push({ name: "dashboard" });
      }
    }
  }
};
</script>
